import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigurationService } from '@common';
import { of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

export interface EresaStock {
    eresa: boolean;
    preresa: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class EresaService {
    public readonly MODES = {
        STANDARD: 1,
        RENEW: 2,
    };

    public readonly RESULTS = {
        OK: 1,
    };

    public result: boolean = false;
    private cache: { [key: string]: EresaStock } = {};

    protected url: string;

    constructor(
        private config: ConfigurationService,
        private http: HttpClient,
    ) {}

    public getStock(gencode) {
        // Récupération dans le cache
        if (this.cache && Object.keys(this.cache).includes(gencode)) {
            const cache = this.cache[gencode];
            return of(cache);
        }

        const httpOptions = {
            headers: { 'api-key': this.config.getData()?.global?.eresa.apikey },
        };

        return this.http.get(`${this.config.getData()?.global?.eresa.stock}${gencode}/status`, httpOptions).pipe(
            map((data: any) => {
                const eresa = data.active && data.activeEreservation === '1';
                const result = {
                    eresa: eresa && data.activePreReservation !== '1',
                    preresa: data.active && data.activePreReservation === '1',
                };

                if (this.cache) {
                    this.cache[gencode] = result;
                }
                return result;
            }),
            timeout(1000),
            catchError((err: any) => {
                throw err;
            }),
        );
    }

    public getProductEresaUrl(product, renew?) {
        const gencode = product.gencode;
        const preorder = product.stock.preresa;
        const campaign_id = product.campaign_id;
        const num = renew ? '1' : '2';
        let url = '';
        if (preorder) {
            const suffix =
                this.config.getData()?.global?.eresa.preorder.indexOf('pre-order') > -1
                    ? `/${campaign_id}/step-store?productId=${gencode}&headerFooter=0&origin=web`
                    : `/${gencode}/action/magasins/storeId/preresa/t/${num}`;
            url = `${this.config.getData()?.global?.eresa.preorder}${suffix}`;
        } else {
            url = `${this.config.getData()?.global?.eresa
                .locator}?productId=${gencode}&isProductLocator=1&headerFooter=0&origin=web`;
        }

        return url;
    }
}
